import styled from "styled-components";

export const ToolbarContainer = styled.div`
  display: flex;
  gap: 1rem;

  padding: 0.75rem 1rem;
  border-bottom: 1px solid ${({ theme }) => theme?.console.tableBorderColor};

  button {
    white-space: nowrap;
  }

  .grid-pagination {
    width: 100%;
  }

  @media (max-width: 600px) {
    flex-wrap: wrap;
  }
`;
